import { combineReducers } from "@reduxjs/toolkit";
import manageUsersReducer from "./manage-users";
import billingReducer from "./billing";
import practiceReducer from "./practice";
import notificationReducer from "./notfication";
import servicesReducer from "./services";
import channelsReducer from "./channels";

const settingReducers = combineReducers({
    practice: practiceReducer,
    billing: billingReducer,
    manage_users: manageUsersReducer,
    notification: notificationReducer,
    services: servicesReducer,
    channels: channelsReducer,
});

export default settingReducers;
